module.exports = __webpack_public_path__ + "img/logo@3x.585f31b7.png";